var pubsub 	= require('pubsub');

module.exports = function () {
	var _icons = document.querySelectorAll('.animated-icons')
	,	animations = []
	,	winH = window.innerHeight

	pubsub.on('resize', function(w, h){
	    winH = h;
	    pubsub.emit('update:posAnim')
	});

	Array.prototype.forEach.call(_icons, function(el){
		switch(el.getAttribute('id')){
			case 'bulb' : initBulb(el); break;
			case 'nl' : initNL(el); break;
			default: break;
		}
	})

	function initBulb(el){
		var anim = {} 
		,	animated = false
		,	_bulbBase = el.querySelector('#bulb-base')
		,	_rays = el.querySelector('#rays')
		,	tl = new TimelineLite({paused:true});

		TweenMax.set(_bulbBase, {transformOrigin: "50% 50%", scale :0})
		TweenMax.set(_rays, {opacity: 0})
		tl.to(_bulbBase, .3, {scale :1, ease:Back.easeOut})
		tl.to(_rays, .05, {opacity: 1})
		tl.to(_rays, .1, {opacity: .1})
		tl.to(_rays, .07, {opacity: 1})
		tl.to(_rays, .1, {opacity: .6})
		tl.to(_rays, .05, {opacity: 1})

		var top = window.pageYOffset || document.documentElement.scrollTop;
		var posYmin = el.getBoundingClientRect().top + top + winH/2
		,	posYmax = posYmin + winH

		pubsub.on('window:scroll', function(scrollY){
			if(isInViewport(el)) tl.play()
			else tl.reverse()
		})
	}

	function initNL(el){
		var animated = false
		,	_base = el.querySelector('#base')
		,	l1 = el.querySelector('#l1')
		,	l2 = el.querySelector('#l2')
		,	l3 = el.querySelector('#l3')
		,	tl = new TimelineLite({paused:true})
		,	tabLines = [l1, l2, l3]
		var posYmin = el.getBoundingClientRect().top - winH/2
		,	posYmax = posYmin + winH*.7
		,	scrollTop = 0

		;
		TweenMax.set(_base, {transformOrigin: "50% 50%", skewX :30, xPercent: -100, opacity:0})
		TweenMax.set(l1, {opacity: 0, xPercent: -50})
		TweenMax.set(l2, {opacity: 0, xPercent: -50})
		TweenMax.set(l3, {opacity: 0, xPercent: -50})

		tl.to(_base, .5, {skewX :0, xPercent: 0, opacity:1, ease: Back.easeOut})
		tl.staggerTo(tabLines, .2, {opacity: 1, xPercent: 0}, 0.1, "-=0.2");

		updatePosAnim()

		// event to update the scroll position that will trigger the animation (blocT1.js, T2, T3)
		pubsub.on('update:posAnim', updatePosAnim)

		pubsub.on('window:scroll', function(scrollY){
			if(isInViewport(el)) tl.play()
			else tl.reverse()
		})

		function updatePosAnim(){
			posYmin = (el.getBoundingClientRect().top - winH/2) + scrollTop
			posYmax = (posYmin + winH*.7) + scrollTop			
		}
	}

	var isInViewport = function (elem) {
		var bounding = elem.getBoundingClientRect();
		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};
	  
}
